import { TYPE_APPLY, TYPE_SCOUT } from "@/User/Constants/user-scout";
import { useTwilioClientContext } from "@/User/Contexts/TwilioClientContext";
import { loadConversationList } from "@/User/Services/ConversationService";
import { transformConversationList } from "@/User/Services/TwilioClientService";
import { usePage } from "@inertiajs/react";
import { useState } from "react";

export const useMessage = () => {
    const { twilioClient } = useTwilioClientContext();
    const { auth: { user } } = usePage().props;

    const defaultData = {
        items: [],
        page: 1,
        hasNext: false,
    };

    const [newConversation, setNewConversation] = useState({
        all: [],
        apply: [],
        scout: []
    });
    const [allConversation, setAllConversation] = useState(defaultData);
    const [scoutConversation, setScoutConversation] = useState(defaultData);
    const [applyConversation, setApplyConversation] = useState(defaultData);
    const [loadingMoreMessages, setLoadingMoreMessages] = useState(false);

    const callLoadMessageList = async ({ page = 1, type = 0 }) => {
        if (!twilioClient) {
            return;
        }

        setLoadingMoreMessages(true);

        const excludeIds = type === TYPE_APPLY ? newConversation.apply
            : type === TYPE_SCOUT
                ? newConversation.scout
                : newConversation.all;

        const converResult = await loadConversationList({ page, type, excludeIds });

        if (!converResult.success) {
            return;
        }

        const twilioConverList = await transformConversationList({
            client: twilioClient,
            dbConversationList: converResult.data,
            userUid: user?.data?.uid
        });

        if (type === TYPE_APPLY) {
            setApplyConversation({
                ...applyConversation,
                items: [
                    ...applyConversation.items,
                    ...twilioConverList,
                ],
                page: page,
                hasNext: converResult.hasNext,
            });
        } else if (type === TYPE_SCOUT) {
            setScoutConversation({
                ...scoutConversation,
                items: [
                    ...scoutConversation.items,
                    ...twilioConverList,
                ],
                page: page,
                hasNext: converResult.hasNext,
            });
        } else {
            setAllConversation({
                ...allConversation,
                items: [
                    ...allConversation.items,
                    ...twilioConverList,
                ],
                page: page,
                hasNext: converResult.hasNext,
            });
        }

        setLoadingMoreMessages(false);
    };

    return {
        newConversation, allConversation, scoutConversation, applyConversation,
        setNewConversation, setAllConversation, setScoutConversation, setApplyConversation,
        callLoadMessageList, loadingMoreMessages
    };
};
